import { Link } from '@atoms/Link';

export const UploadPhotoTextContent = () => {
  const imageDisclaimerLink = {
    href: 'https://www.westminster.gov.uk/data-protection/report-it-image-disclaimer',
    text: 'Find out how we will be using your image.',
  };

  return (
    <div className="text-bodyLg my-4 flex flex-col gap-4">
      <p>
        Photos help us locate and assess the issue.{` `}
        <Link
          href={imageDisclaimerLink.href}
          className="inline font-normal"
          linkType="inline"
          title="Opens in a new tab"
          external={true}
        >
          {imageDisclaimerLink.text}
        </Link>
      </p>
      <p>
        You can upload up to 5 images. You can upload JPEG, PNG, GIF or WebP
        files.
      </p>
      <p>
        Images help us to confirm the type of issue and helps with our
        processes.
      </p>
    </div>
  );
};
